'use strict';
import moment from 'moment';

angular
  .module('myConsultApp')
  .filter('dateparse', function ($filter) {
    return function (input) {
      if (input == null) {
        return '';
      }
      var datePart = input.split(/[- :]/);
      var dateNew = new Date(
        datePart[0],
        datePart[1] - 1,
        datePart[2],
        datePart[3],
        datePart[4],
        datePart[5],
      );
      var _date = $filter('date')(new Date(dateNew), 'MM-dd-yyyy HH:mm:ss');
      return _date.toUpperCase();
    };
  })
  .filter('dateFormat', function ($filter) {
    return function (dateObj) {
      var dateObj = new Date(dateObj);
      var _date = $filter('date')(dateObj, 'MMM, dd yyyy HH:mm a');
      return _date;
    };
  })
  .filter('dateInMMDDYY', function () {
    return function (date) {
      return moment(date).format('MM-DD-YY');
    };
  })
  .filter('dateInMMDDYYYY', function () {
    return function (date) {
      if (date) {
        return moment(date).format('MM/DD/YYYY');
      } else {
        return '';
      }
    };
  })
  .filter('dateInMMDDYYYWithHyphen', function () {
    return function (date) {
      return moment(date).format('MM-DD-YYYY');
    };
  })
  .filter('dateInMMDDYYYWithPurchase', function () {
    return function (date) {
      return moment(date).tz('UTC').format('MM-DD-YYYY');
    };
  })
  .filter('dateInMMDDYYYWithTime', function () {
    return function (date) {
      return moment(date).tz('UTC').format('MM-DD-YYYY HH:mm:ss');
    };
  })
  .filter('toDollarAmount', function () {
    return function (dollar) {
      var dollarAmount = parseInt(dollar) / 10;
      dollarAmount = dollarAmount.toFixed(2);
      return '$' + dollarAmount.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0];
    };
  })
    .filter('toHtml', function () {
      return function (error) {
        return error.split('/n').join('\n')
      };
  });
